module.exports = __webpack_public_path__ + "static/media/comdlg32_537.10a1bad8.ico";